/** Double authentification, facultative pour un compte client (Franck,
 *  08/10/2026) : chacun l'active pour lui-meme dans Parametres. Le serveur
 *  redemande le mot de passe avant de produire le secret. */
import { useEffect, useState } from "react";

import { api, type Moi } from "../api";
import { ActivationMfa } from "./ActivationMfa";

export function DoubleAuthentification() {
  const [moi, setMoi] = useState<Moi | null>(null);
  const [motDePasse, setMotDePasse] = useState("");
  const [activation, setActivation] = useState(false);

  useEffect(() => {
    void api.moi().then(setMoi, () => setMoi(null));
  }, []);

  if (!moi) return null;
  if (activation) {
    return (
      <ActivationMfa email={moi.email} motDePasse={motDePasse}
                     onActivee={() => { setActivation(false); setMotDePasse(""); setMoi({ ...moi, mfa_enabled: true }); }}
                     onAnnuler={() => setActivation(false)} />
    );
  }

  return (
    <div className="card" style={{ marginBottom: "1.5rem" }}>
      <h2 className="card__title" style={{ fontSize: "1.1rem" }}>Double authentification</h2>
      {moi.mfa_enabled ? (
        <p style={{ margin: 0 }}><strong>Activée.</strong> Un code de votre application vous est demandé à chaque
          connexion.</p>
      ) : (
        <form className="stack" onSubmit={(e) => { e.preventDefault(); if (motDePasse) setActivation(true); }}>
          <p className="muted" style={{ margin: 0 }}>
            Facultative et recommandée : un code de votre téléphone s'ajoute au mot de passe à chaque connexion.
          </p>
          <div className="field" style={{ maxWidth: "22rem" }}>
            <label className="field-label" htmlFor="mfa-mdp">Votre mot de passe, pour confirmer</label>
            <input id="mfa-mdp" className="input" type="password" autoComplete="current-password"
                   value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} />
          </div>
          <div className="actions" style={{ marginTop: 0 }}>
            <button type="submit" className="btn btn--primary" disabled={!motDePasse}>Activer</button>
          </div>
        </form>
      )}
    </div>
  );
}
